module.exports = __webpack_public_path__ + "img/Hand_31_05_27.fe43fbef.png";